import { CheckOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { observer } from 'mobx-react';
import { useApplicationSelectionStore } from '~contexts/mobx';
import { useCheckNavigation } from '~contexts/unsaved-changes';
import { ApplicationSelection } from '~types/app-selection';
import './styles.scss';

const applications = [
    {
        label: 'All regions',
        value: ApplicationSelection.ALL_REGIONS,
        icon: '/all-regions-logo.png',
    },
    {
        label: 'Couche-Tard',
        value: ApplicationSelection.COUCHE_TARD,
        icon: '/ct-logo-xl.svg',
    },
    {
        label: 'Circle K',
        value: ApplicationSelection.CIRCLE_K,
        icon: '/circle-k-xl-logo.svg',
    },
];

export const ApplicationSelector = observer(() => {
    const applicationSelectionStore = useApplicationSelectionStore();
    const { checkNavigation } = useCheckNavigation();

    const handleChange = (value: ApplicationSelection) => {
        if (value === applicationSelectionStore.selectedApplication) {
            return;
        }
        checkNavigation(() => {
            applicationSelectionStore.setSelectedApplication(value);
        });
    };

    return (
        <Select
            className="application-selector"
            popupClassName="application-selector-dropdown"
            placeholder="Select application"
            value={applicationSelectionStore.selectedApplication}
            onChange={handleChange}
        >
            {applications.map((app) => (
                <Select.Option
                    key={app.value}
                    value={app.value}
                    label={
                        <div className="application-selector-label">
                            <img loading="lazy" src={app.icon} alt="logo" />
                            <span>{app.label}</span>
                        </div>
                    }
                >
                    <div className="application-selector-option">
                        <div className="application-selector-left">
                            <img loading="lazy" src={app.icon} alt="logo" />
                            <span>{app.label}</span>
                        </div>
                        {applicationSelectionStore.selectedApplication ===
                            app.value && (
                            <CheckOutlined className="application-selector-check" />
                        )}
                    </div>
                </Select.Option>
            ))}
        </Select>
    );
});
